import React, { useEffect } from "react";
import Image from "next/image";
import Meta from "../../../components/Meta";
import { useSelector, useDispatch } from "react-redux";
import { Tranding_category } from "../../../components/component";
import { NewsLetter } from "../../../components/component";
import NowVurbmotoProspect from "../../../components/now-vurbmoto-prospect-section/now-vurbmoto-prospect-section";
const Index = () => {
  return <>
      <Meta title="Current Champions || AmateurMoto.com | Current Champions at Loretta Lynns" data-sentry-element="Meta" data-sentry-source-file="index.jsx" />
      {/* <!-- Rankings --> */}
      <NowVurbmotoProspect data-sentry-element="NowVurbmotoProspect" data-sentry-source-file="index.jsx" />
    </>;
};
export default Index;